/**
 * Main Theme JavaScript
 * You & Me Agency Shopify Theme
 */

// Wait for DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  console.log('You & Me Agency Theme Loaded');
  
  // Initialize all interactions if available
  if (typeof initAllInteractions === 'function') {
    initAllInteractions();
  }
}

